import React from 'react';
import moment from 'moment';
import { grey } from '@mui/material/colors';
import { Stack } from '@mui/material';
import { DateCalendar } from '@mui/x-date-pickers';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';

interface Props {
  date: Date;
  onNavigate: (date: Date) => void;
}

export const MiniCalendar = ({ date, onNavigate }: Props) => {
  return (
    <Stack borderRadius="0.5rem" border={`1px solid ${grey[200]}`}>
      <LocalizationProvider dateAdapter={AdapterMoment}>
        <DateCalendar
          value={moment(date)}
          onChange={value => {
            if (value) onNavigate(value.toDate());
          }}
        />
      </LocalizationProvider>
    </Stack>
  );
};
